module.exports = __webpack_public_path__ + "static/media/bullet.18dd4cf3.svg";